
import { useState, useEffect } from 'react';

interface QuizHeroProps {
  onStart: () => void;
}

export default function QuizHero({ onStart }: QuizHeroProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c355d1d7e2a78c773814211c2bf5d4d1.jpg"
          alt="Descubra seu perfil de autoconhecimento"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      <div className="absolute top-20 right-32 w-2 h-2 bg-gold-400/50 rounded-full animate-float"></div>
      <div className="absolute top-44 left-40 w-1.5 h-1.5 bg-gold-500/40 rounded-full animate-float" style={{ animationDelay: '1.5s' }}></div>
      <div className="absolute bottom-32 right-60 w-1 h-1 bg-gold-300/60 rounded-full animate-float" style={{ animationDelay: '0.8s' }}></div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className={`max-w-3xl mx-auto text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-10 h-px bg-gradient-to-r from-transparent to-gold-500"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">Quiz Interativo</span>
            <div className="w-10 h-px bg-gradient-to-l from-transparent to-gold-500"></div>
          </div>

          <h1 className="font-['Playfair_Display'] text-5xl lg:text-7xl leading-[1.1] mb-6 text-white">
            <span className="block font-light">Descubra seu</span>
            <span className="block italic text-gold-400 mt-2">perfil de</span>
            <span className="block font-bold mt-2">autoconhecimento</span>
          </h1>

          <p className="font-['Montserrat'] text-base lg:text-lg text-white/50 mb-12 leading-relaxed max-w-xl mx-auto font-light tracking-wide">
            Responda 7 perguntas e descubra qual é o seu perfil único na jornada de autoconhecimento. Leva menos de 2 minutos.
          </p>

          <button
            onClick={onStart}
            className="group relative bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-sm px-12 py-4 rounded-lg hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all duration-500 hover:scale-105 inline-flex items-center gap-3 whitespace-nowrap cursor-pointer tracking-wider uppercase"
          >
            Começar o Quiz
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-2 transition-transform duration-300"></i>
          </button>

          <div className={`mt-14 flex items-center justify-center gap-8 transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line text-gold-500/60 text-sm"></i>
              </div>
              <span className="font-['Montserrat'] text-xs text-white/30 tracking-wide">2 minutos</span>
            </div>
            <div className="w-px h-4 bg-white/10"></div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-question-line text-gold-500/60 text-sm"></i>
              </div>
              <span className="font-['Montserrat'] text-xs text-white/30 tracking-wide">7 perguntas</span>
            </div>
            <div className="w-px h-4 bg-white/10"></div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-user-star-line text-gold-500/60 text-sm"></i>
              </div>
              <span className="font-['Montserrat'] text-xs text-white/30 tracking-wide">4 perfis</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="font-['Montserrat'] text-[10px] text-gold-500/50 uppercase tracking-[0.3em]">Descubra-se</span>
        <div className="w-px h-8 bg-gradient-to-b from-gold-500/50 to-transparent animate-shimmer"></div>
      </div>
    </section>
  );
}
